<div class="ui-g ui-fluid">
<p-toast ></p-toast>
    <div class="ui-g-12 ui-md-12 ui-lg-12" class="background">
      <div class="ui-g-12 ui-md-12 ui-lg-12 " *ngIf="this.user != null" class="title1" >Hola {{this.user['policyHolderCompleteName'].substr(0,this.user['policyHolderCompleteName'].indexOf(' '))}} , </div>
      <div class="ui-g-12 ui-md-12 ui-lg-12" class="title1">{{this.titleWelcome}}</div>
    </div>
  <div class="ui-g-12 ui-md-12 ui-sm-12">
    <div class="ui-g-12 ui-md-4 ui-lg-3">
      <div class="cardBorder">
        <div>
          <h2 class="noMg">{{this.titleCard}}</h2>
          <h3 class="mg-top">{{this.subTitleDigital}}</h3>
        </div>
        <div style="display: flex; align-items: center;"><img src="../../assets/images/homeRPN/carne-digital.png" alt="rpn"  style="margin: 20px auto;"></div>
        <div> <button  pButton type="button" class="ui-button-primary btn-dv" style="width: 100%;" label="{{this.btnDownload}}" (click)="navigate(options[0].url)"></button></div>  
      </div>
    </div>
    <div class="ui-g-12 ui-md-8 ui-lg-9">
        <div class="ui-g-12" style="padding: 0;">
          <div class="ui-g-12 ui-md-6 ui-lg-4">
            <div class="card">
              <div style="display: flex; align-items: center;"><img src="../../assets/images/homeRPN/cosulta-proveedores.png" alt="rpn" style="margin: 10px auto;" ></div>
              <div> <button  pButton type="button" class="ui-button-primary btn-dv" style="width: 100%; height: 62px !important;" label="{{this.btnProviders}}"  (click)="navigateComponent('providers')" ></button></div>  
            </div>
          </div>
          <div class="ui-g-12 ui-md-6 ui-lg-4" *ngIf="!env.usrHN">
            <div class="card">
              <div style="display: flex; align-items: center;"><img src="../../assets/images/homeRPN/consulta-cupones.png" alt="rpn" style="margin: 10px auto;" ></div>
              <div (click)="getCoupons()"> <button  pButton type="button" class="ui-button-primary btn-dv" style="width: 100%;height: 62px !important; font-size: 13px !important;padding-top: 0px !important; padding-bottom: 0px !important;" label="{{this.btnCoupons}}" ></button></div>  
            </div>
          </div>
          <div class="ui-g-12 ui-md-6 ui-lg-4" *ngIf="env.usrGTM">
            <div class="card" >
              <div style="display: flex; align-items: center;"><img src="../../assets/images/homeRPN/cupones-chequeo.png" alt="rpn" style="margin: 10px auto;"></div>
              <div> <button  pButton type="button" class="ui-button-primary btn-dv" style="width: 100%; height: 62px !important;" label="{{this.btnCheckCoupons}}" (click)="navigateComponent('coupons')"></button></div>  
            </div>
          </div>
        </div>
    </div>
    <div class="ui-g-12 ui-md-12 ui-lg-9">
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <div class="cardBlue" (click)="navigateComponent('authorizations')" style="cursor:pointer;">
          <div  style="display: flex; align-items: center;"><img src="../../assets/images/homeRPN/autorizaciones.png" alt="rpn" style="margin: 10px auto;"></div>
          <div> <h2 class="noMg textWhite">Consulta</h2> <h3 class="mg-top textWhite noMg">Autorizaciones</h3> </div>  
        </div>
      </div>
      <div class="ui-g-12 ui-md-8 ui-lg-8">
        <div class="card" >
          <div class="ui-g ui-fluid">
            <div class="ui-g-12">
              <div class="ui-g-12 ui-md-4 ui-lg-4" style="display: flex; align-items: center;">
             
               <div class="avatar" style="margin: 0 auto;" [style.background]="'url(' + urlImage + ')'" >
                <!--<button  pButton type="button" class="ui-button-primary ui-button-rounded" icon="pi pi-plus" style="display: flex; right: -65px; top: 60px;"></button>-->
                <!--<p-fileUpload mode="basic" name="demo[]" class="ui-button-primary ui-button-rounded" style="display: flex; right: -65px; top: 60px;position: relative;width: 35px;height: 35px;border-radius: 100% !important;" url="/home/profile" accept="image/*" maxFileSize="1000000" (onUpload)="onBasicUpload($event)" chooseLabel=""></p-fileUpload>-->
                <!--<p-fileUpload 
                  #fubauto 
                  mode="basic" 
                  name="demo[]" 
                  url="./" 
                  accept="image/*" 
                  maxFileSize="1000000" 
                  (onUpload)="onBasicUploadAuto($event)" 
                  [auto]="true" 
                  chooseLabel=""
                  class="ui-button-primary ui-button-rounded" 
                  style="display: flex; right: -65px; top: 60px;position: relative;width: 35px;height: 35px;border-radius: 100% !important;">
                </p-fileUpload>-->
                <p-fileUpload 
                  name="myfile[]" 
                  mode="basic"
                  [customUpload]="true" 
                  [auto]="true"
                  chooseLabel=""
                  (uploadHandler)="myUploader($event)"
                  class="ui-button-primary ui-button-rounded" 
                  style="display: flex; right: -65px; top: 60px;position: relative;width: 35px;height: 35px;border-radius: 100% !important; ">
                </p-fileUpload>
              </div>
              </div>
              <div class="ui-g-8" (click)="navigate(options[4].url)" style="cursor:pointer;">
                <h2 class="mg-top"><h2>Perfil</h2></h2>
                <div><h4 class="noMg">Póliza</h4></div>
                <div class="border-bttm"  *ngIf="this.user != null"><h3 class="mg-top subTitle">{{this.user['policy']}}</h3></div>
                <div class="p-text-left"><h4 style="margin-bottom: 0">Nombre de la empresa</h4> </div>
                <div class="p-text-left " *ngIf="this.user != null"><h3 class="mg-top subTitle">{{this.user['companyName']}}</h3> </div>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </div>
  </div>
  <p-dialog [(visible)]="showCoupons" (close)="showCoupons=false" [closable]="true" [style]="{width: '70vw'}">
    <div class="ui-g-12">
      <div class="cardGray ui-g-12">
        <div class="ui-g-12 ui-md-12 ui-sm-12" *ngIf="coupons">
          <div class="ui-g-12">
            <div class="card background" >
              <p class="subTitleW">Cupones de consultas disponibles</p>
            </div>
          </div>
          <!--<div class="ui-lg-4 ui-md-4 ui-g-12">
            <div class="card ui-g-12">
              <h4 class="info">TIpo:</h4>
              <p class="number">{{coupons.limitType}}</p>
            </div>
          </div>-->
          <div class="ui-lg-4 ui-md-4 ui-g-12">
            <div class="card ui-g-12">
              <h4 class="info">Limite:</h4>
              <p class="number"> {{coupons.couponsLimit}}</p>
            </div>
          </div>
          <div class="ui-lg-4 ui-md-4 ui-g-12">
            <div class="card ui-g-12">
              <h4 class="info">Usados:</h4>
              <p class="number"> {{coupons.couponsUsed}}</p>
            </div>
          </div>
          <div class="ui-lg-4 ui-md-4 ui-g-12">
            <div class="card ui-g-12">
              <h4 class="info">Disponibles:</h4>
              <p class="number">{{coupons.couponsAvailable}}</p>
            </div>
          </div>
          <div class="ui-lg-4 ui-md-4 ui-g-12">
            <div class="card ui-g-12">
              <h4 class="info">Certificado:</h4>
              <p class="number">{{coupons.certificate}}</p>
            </div>
          </div>
          <div class="ui-lg-4 ui-md-4 ui-g-12">
            <div class="card ui-g-12">
              <h4 class="info">Miembros:</h4>
              <p class="number"> {{coupons.certificateMembers}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-dialog>
  <p-dialog [(visible)]="showCardNumber" [style]="{width: '60vw'}" [closable]="true">
    <div class="ui-g-12">
      <p-galleria [value]="images" [numVisible]="1"   
      [circular]="true" [showItemNavigators]="true" [showThumbnails]="false">
        <ng-template pTemplate="item" let-item>
            <img [src]="item.previewImageSrc" [alt]="item.alt" style="width: 100%;"/>
        </ng-template>
      </p-galleria>
    </div>
   
</p-dialog>


<div class="container" *ngIf="!env.usrGTM && !env.usrHN">
  <input type="checkbox" id="btn-mas">
  <div class="redes">
      <a href="#" class="chatRPN"  href="javascript://Chat" onclick="liveagent.startChat('5734T000000H7pA')">
        <img src="../../assets/images/homeRPN/chat.svg" alt="" width="52px">
      </a>
      <a href="https://wa.me/50325266800" class="whatsapp" target="_blank">
        <img src="../../assets/images/homeRPN/whatsapp.svg" alt="" width="40px">
      </a>
  </div>
  <div class="btn-mas">
      <label for="btn-mas" width="40px"  width="15px">
        <img src="../../assets/images/homeRPN/chat.png" alt="" width="40px">
      </label>
  </div>
</div>

  
<script src="https://kit.fontawesome.com/eb496ab1a0.js" crossorigin="anonymous"></script>
  <script type="text/javascript">

      if (!window._laq) { window._laq = []; }
      window._laq.push(function(){liveagent.showWhenOnline('5734T000000H7pA', document.getElementById('liveagent_button_online_5734T000000H7pA'));
      liveagent.showWhenOffline('5734T000000H7pA', document.getElementById('liveagent_button_offline_5734T000000H7pA'));
      
      });
  </script>
  
  <script type='text/javascript' src='https://c.la4-c1-ia2.salesforceliveagent.com/content/g/js/57.0/deployment.js'></script>
  <script type='text/javascript'>
      liveagent.init('https://d.la4-c1-ia2.salesforceliveagent.com/chat', '5724T000000Xuhm', '00D4T000000FucN');
  </script>
</div>
